import axios from 'axios';

import { AUTH_USER_OUT } from 'store/modules/auth/types';
import getEnv from 'helpers/getEnv';

export class Api {
  static client = null;

  static init(store) {
    if (!Api.client) {
      Api.client = axios.create({
        baseURL: getEnv('REACT_APP_BACKEND_URL'),
      });

      Api.client.interceptors.request.use(config => {
        const newConfig = config;
        const {
          auth: { token },
        } = store.getState();

        newConfig.headers.authorization = token;

        return newConfig;
      });

      Api.client.interceptors.response.use(
        response => response,
        error => {
          if (error.response.status === 401) {
            store.dispatch({
              type: AUTH_USER_OUT,
            });
          }
          return Promise.reject(error);
        },
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ApiClient.js